import Nav from '@lcsc-ui/components/Nav';

const XinpinLayout = ({ children, breadcrumb = [] }) => {
  // 将breadcrumb转换为Nav组件需要的navList格式
  const navList = breadcrumb.map((item) => ({
    name: item.text,
    url: item.href || '',
    spm: item.spm || '',
  }));

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="w-[1260px] mx-auto relative">
        {navList.length > 0 && (
          <section className="pt-[16px] pb-[15px] px-[30px]">
            <Nav navList={navList} showLastArrow={false} />
          </section>
        )}
        {children}
        <div
          className="bg_left absolute top-[53px] -left-[352px] w-[360px] h-[480px] bg-no-repeat bg-[length:360px_491px] pointer-events-none"
          style={{
            backgroundImage: 'url("//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/bg_left.jpg")',
            backgroundPosition: '0 0',
          }}
        ></div>
        <div
          className="bg_right absolute top-[53px] -right-[352px] w-[360px] h-[480px] bg-no-repeat bg-[length:360px_491px] pointer-events-none"
          style={{
            backgroundImage: 'url("//static.szlcsc.com/ecp/assets/web/page/www/xinpinGD32E231/images/bg_right.jpg")',
            backgroundPosition: '0 0',
          }}
        ></div>
      </div>
    </div>
  );
};

export default XinpinLayout;
